import { log } from 'log';
import uuid from 'uuid-random';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { validateGeolocation } from 'js/hooks/auth/pas';
import { useOnClose } from 'js/components/common/PopupManager';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { showGeoComplyPopupAction } from '../../../actions';

export const DOWNLOAD_POPUP_ID = uuid();

export const useOnError = ({ sdk, transactionID, downloadPLC, setShowOverlay, useTransparentPopup }) => {
    const onClose = useOnClose();
    const onRefresh = useCallback(() => window.location.reload(), []);
    const dispatch = useDispatch();

    return useCallback(async (errorCode) => {
        publicEventsAPIService.trigger('geofencing-error', { transactionID, errorCode });

        log('gcErr', { transactionID, errorCode });

        switch (errorCode) {
            case sdk.CLNT_ERROR_LOCAL_SERVICE_UNSUP_VER:
            case sdk.CLNT_ERROR_LOCAL_SERVICE_UNAVAILABLE:
            case sdk.CLNT_ERROR_LOCAL_SERVICE_COMMUNICATION:
                // show popup that module is not installed
                setShowOverlay(false);
                dispatch(showGeoComplyPopupAction({
                    id: DOWNLOAD_POPUP_ID,
                    title: 'playtech.mobile.system.geocomply.popups.plcNotFound.title',
                    content: 'playtech.mobile.system.geocomply.popups.plcNotFound.content',
                    isModal: true,
                    buttons: [
                        {
                            onClick: downloadPLC,
                            text: 'playtech.mobile.system.geocomply.popups.plcNotFound.download'
                        },
                        {
                            onClick: onClose,
                            text: 'playtech.mobile.system.geocomply.popups.plcNotFound.ignore',
                            color: 'negative'
                        },
                        {
                            onClick: onRefresh,
                            text: 'playtech.mobile.system.geocomply.popups.plcNotFound.refresh',
                            color: 'info'
                        }
                    ],
                    useTransparentPopup
                }));
                break;
            case sdk.CLNT_ERROR_INVALID_LICENSE_FORMAT:
                // show popup with general error
                setShowOverlay(false);
                dispatch(showGeoComplyPopupAction({
                    title: 'playtech.mobile.system.geocomply.popups.error.title',
                    content: 'playtech.mobile.system.geocomply.popups.error.communicationError',
                    useTransparentPopup
                }));

                break;
            // case sdk.CLNT_ERROR_REQUEST_GEOLOCATION_IN_PROGRESS:
            default:
                setShowOverlay(false);

                try {
                    await validateGeolocation(null, null, null, transactionID, errorCode, 'geocomply');
                } catch (e) {
                    // noop
                }
        }
    }, [
        sdk,
        onClose,
        onRefresh,
        transactionID,
        downloadPLC,
        dispatch,
        setShowOverlay,
        useTransparentPopup
    ]);
};
